import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import Opinie_wyb2 from './Opinie_wyb2';
import NavBar from './NavBar';
import Zak_opiniowanie from './Zak_opiniowanie';
import Popup from "reactjs-popup";
import Opiniuj2 from './Opiniuj2';

export default class Opinie2 extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    token: sessionStorage.getItem('token'),
    nazwastrony: 'Opinie2',
    dataopinie1: [],
    dataopinie2: [],
    rok: props.rok,
    indexwyb: props.indexwyb,
    DWBP: props.DWBP,
    idWydzialu: props.idWydzialu,
    idUchwaly: props.idUchwaly,
    tab2: false,
    open: false,
    open2: false,
    loadingdata: true,
    zData: [],
    nzData: [],
    czyOpiniodawca: true,
    opiniowanieData: [],
    opiniowanieValue: null,
    wlasneData: [],
    loadingStatusyOpinii: false,
  }

  this.getdata1();
  this.closeModal = this.closeModal.bind(this);
  this.closeModal2 = this.closeModal2.bind(this);
}

closeModal () {
  this.setState({ open: false })
}
closeModal2 () {
  this.setState({ open2: false })
}

componentDidMount(){
  ReactDOM.render(<NavBar token = {this.state.token} username = {this.state.username} id = {this.state.id} rok = {this.state.rok} nazwastrony = {this.state.nazwastrony} kodoper = {this.state.kodoper} />, document.getElementById("header")); 
  
  const konfig =  JSON.parse(sessionStorage.getItem("konfig")) ? JSON.parse(sessionStorage.getItem("konfig")) : [];

  this.setState({ 
    czyOpiniodawca: konfig.opiniodawca,
  })


  // axios
  //   .get(apiurl+"api/Konfig", {params : { rok : this.state.rok }, headers: { 'Authorization' : "Bearer " + this.state.token }})
  //   .then(response =>
  //     this.setState({ 
  //       czyOpiniodawca: response.data.opiniodawca,
  //      })
  //   )
  //   .catch(error =>swal(error.response.data));
}

getdata1 = () => {
  axios
    .get(apiurl+"api/Opinie2/Get1",{ params: { rok : this.props.rok },  headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>{
      this.sortData(response.data);
    }
    )
    .catch(error => {swal(error.response.data.Message); this.setState({ loadingdata: false })} );
}




sortData = (data) => {
  const zData = [];
  const nzData = [];
  const wData = [];
  data.map((dane, idx) => {
      if(dane.wlasne){
          wData.push(dane)
          return wData
      }
      else {
        if(dane.dataZamk === null) {
          zData.push(dane)
          return zData
        } else {
          nzData.push(dane)
          return nzData
        }
      }
  })
  this.setState({ zData: zData, nzData: nzData, wlasneData: wData, loadingdata: false })
  }

  getParsedDate(strDate){
    if(strDate === null) { return 'Brak'} else {
      var strSplitDate = String(strDate).split(' ');
      var date = new Date(strSplitDate[0]);
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      
      var yyyy = date.getFullYear();
      if (dd < 10) {
          dd = '0' + dd;
      }
      if (mm < 10) {
          mm = '0' + mm;
      }
      date =  dd + "-" + mm + "-" + yyyy;
      return date.toString();
    }
  }

  opiniowaniModalGet(id, idU, idW, archiwum) {
    this.setState({ idUPop: idU, idWPop: idW, archPop: archiwum, idWybOpin: id})
    axios
    .get(apiurl+"api/Opinie2/Opiniodawcy", { params: { rok: this.state.rok, idUchwaly: idU, idWydzialu: idW }, headers: { 'Authorization' : "Bearer " + this.state.token }})
    .then(response =>
      this.setState({ opiniowanieData: response.data })
    )
    .catch(error =>swal(error.response.data), this.setState({ isVisible3: true }));
  }

  postOpiniowanie = (e) => {
    e.preventDefault();
    const data = JSON.parse(this.state.opiniowanieValue);
    const dataNow = new Date();
  
    axios.post(apiurl+"api/Opinie2/Post1", {
      id: this.state.idWybOpin,
      rok: Number(this.state.rok),
      idUchwaly: Number(this.state.idUPop),
      idWydzialu: Number(this.state.idWPop),
      idOpiniodawcyDo: data.idOpiniodawcy,
      kodOperDo: data.kodOper,
      dataOtw: dataNow,
      kodOper: null,
      idOpiniodawcy: null,
      uwagi: null,
      status: null,
      dataZamk: null,
      nazwaWydzialu: null,
      nazwaUchwaly: null,
      archiwum: this.state.archPop,
    },
    {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      swal('Zapisano')
    })
    .catch(error => {
        swal(error.response.data) 
    });
  }

  deleteOpiniowanie() {

    swal({
      title: 'Czy na pewno chcesz usunąć wszystkie opinie dla tego dokumentu?',
      buttons: {
      cancel: "Anuluj",
      catch: {
        text: "Tak",
        value: "willDelete",} 
      },
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        axios.delete(apiurl + "api/Opinie2/UsunOpinie", { params: { rok: this.state.rok, idUchwaly: this.state.idUPop }, headers: { 'Authorization' : "Bearer " + this.state.token } })
        .then(res => {
          swal(res.data);
        })
        .catch(error => swal(error.response.data))
      } else { return null }
    });
  }


  opiniowanieStatus(idUchw, idWydz) {
    this.setState({ loadingStatusyOpinii: true });
    axios
      .get(apiurl+"api/Opinie2/StatusyOp", { params: { rok: this.state.rok, idUchwaly: idUchw }, headers: { 'Authorization' : "Bearer " + this.state.token }})
      .then(response => {
        const dataWydzial = response.data.filter(item => item.idWydzialu === idWydz);
        this.setState({ opiniowanieStatusData: dataWydzial, loadingStatusyOpinii: false })
      } )
      .catch(error =>swal(error.response.data), this.setState({ loadingStatusyOpinii: false }));
  }

  

render() {
let { rok, zData, nzData, wlasneData, loadingdata, czyOpiniodawca, opiniowanieData, opiniowanieValue, opiniowanieStatusData, loadingStatusyOpinii } = this.state;

return (
<React.Fragment>
<div className="container-fluid">
<h1>Opinie</h1>

<hr />
<div className="col h-100">
<div className="fluid-row h-50 mb-3">
  <h4>Do zaopiniowania</h4>
  <div className="table-responsive m-1 card">
  {loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }
  <table class="table" width="100%">
    <thead>
      <tr>
        <th width="5%"><span>LP.</span></th>
        <th width="25%"><span>Dokument</span></th>
        <th width="30%"><span>Wydział</span></th>
        <th width="20%"><span>Status</span></th>
        <th width="20%"><span>Uwagi</span></th>
        <th width="15%"><span>Data otwarcia</span></th>
        <th width="15%"><span>Data zamknięcia</span></th>
        {czyOpiniodawca && <th width="10%"><span>Opiniuj</span></th>}
        {czyOpiniodawca && <th width="10%"><span>Wybierz</span></th>}
        <th width="10%"></th>
      </tr>
    </thead>
    <tbody>
    {zData.length > 0 ? (zData.map((data, index) => {
        const { nazwaUchwaly, nazwaWydzialu, dataOtw, status, uwagi, dataZamk, idUchwaly, id, idWydzialu, nazwaOpiniodawcyDo } = data;
        let { indexwyb } = this.state;
        let lp = index + 1;
        return (<>
        <tr className={index === indexwyb ? "opiniawyb" : null}>
            <td>{lp}</td>
            <td>{nazwaUchwaly}</td>
            <td>{nazwaWydzialu}</td>
            <td>{status}</td>
            <td>{uwagi}</td>
            <td>{this.getParsedDate(dataOtw)}</td>
            <td>{this.getParsedDate(dataZamk)}</td>
            {czyOpiniodawca && <td><button type="button" class="btn btn-light btn-sm" onClick={() => ( this.setState({ open2 : true, idUchwaly: idUchwaly, idWydzialu: idWydzialu, uwagi: uwagi, idopini: id, nazwaOpiniodawcyDo: nazwaOpiniodawcyDo }) )} >Opiniuj</button></td>}
            {czyOpiniodawca && <td><button class="btn btn-light text-nowrap btn-sm" onClick={() => ( ReactDOM.render(<Opinie_wyb2 rok={rok} idopini={id} idUchwaly={idUchwaly} idWydzialu={idWydzialu} nazwaUchwaly={nazwaUchwaly} nazwaWydzialu={nazwaWydzialu} uwagi={uwagi} indexwyb={indexwyb} />, document.getElementById("root")) )}>Edytuj plan</button></td>}
            <td><button type="button" class="btn btn-light text-nowrap btn-sm"  data-toggle="modal" data-target="#opinieStatusyModal" onClick={() => (this.opiniowanieStatus(idUchwaly, idWydzialu))}> Statusy opinii </button></td>
        </tr>
        </>);
      })) : (<tr>
              <td colSpan="10"><center><b>Brak danych</b></center></td>
            </tr>)}
    </tbody>
  </table>
  </div>

  <h4 className='mt-2'>Zaopiniowane</h4>
  <div className="table-responsive m-1 card">
  {loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }

  <table class="table" width="100%">
    <thead>
      <tr>
        <th width="5%"><span>LP.</span></th>
        <th width="25%"><span>Dokument</span></th>
        <th width="20%"><span>Wydział</span></th>
        <th width="20%"><span>Status</span></th>
        <th width="20%"><span>Uwagi</span></th>
        <th width="15%"><span>Data otwarcia</span></th>
        <th width="15%"><span>Data zamknięcia</span></th>
        <th width="20%"></th>
      </tr>
    </thead>
    <tbody>
    {nzData.length > 0 ? (nzData.map((data, index) => {
        const { id, nazwaUchwaly, nazwaWydzialu, dataOtw, status, uwagi, dataZamk, idWydzialu, idUchwaly, archiwum, btnSendNext} = data;
        let { indexwyb } = this.state;
        let lp = index + 1;
        return (<>
        <tr className={index === indexwyb ? "opiniawyb" : null}>
            <td>{lp}</td>
            <td>{nazwaUchwaly}</td>
            <td>{nazwaWydzialu}</td>
            <td>{status}</td>
            <td>{uwagi}</td>
            <td>{this.getParsedDate(dataOtw)}</td>
            <td>{this.getParsedDate(dataZamk)}</td>
            <td className='d-flex flex-row'>
              {btnSendNext && (czyOpiniodawca && (status === 'P' || status === 'Z')) ? <button type="button" class="btn btn-light text-nowrap btn-sm" data-toggle="modal"  data-target="#opiniowanieModal" onClick={() => ( this.opiniowaniModalGet(id, idUchwaly, idWydzialu, archiwum))} >Prześlij dalej</button> : null }
              <button type="button" class="btn btn-light text-nowrap  btn-sm ml-1"  data-toggle="modal" data-target="#opinieStatusyModal" onClick={() => (this.opiniowanieStatus(idUchwaly, idWydzialu))}> Statusy opinii </button>
            </td>
            {/* <td><button type="button" class="btn btn-light " onClick={() => ( this.setState({ open2 : true, idUchwaly: idUchwaly, idWydzialu: idWydzialu, uwagi: uwagi, idopini: id }) )} >Opiniuj</button></td>
            <td><button class="btn btn-light text-nowrap" onClick={() => ( ReactDOM.render(<Opinie_wyb2 rok={rok} idopini={id} idUchwaly={idUchwaly} idWydzialu={idWydzialu} nazwaUchwaly={nazwaUchwaly} nazwaWydzialu={nazwaWydzialu} uwagi={uwagi} indexwyb={indexwyb} />, document.getElementById("root")) )}>Edytuj plan</button></td> */}
        </tr>
        </>);
      })) : (<tr>
            <td colSpan="9"><center><b>Brak danych</b></center></td>
          </tr>)}
    </tbody>
  </table>
  </div>

  {czyOpiniodawca ? (<><h4 className='mt-2'>Przesłane</h4>
  <div className="table-responsive m-1 card">
  {loadingdata ? (<center><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></center>) : null }

  <table class="table" width="100%">
    <thead>
      <tr>
        <th width="5%"><span>LP.</span></th>
        <th width="25%"><span>Dokument</span></th>
        <th width="30%"><span>Wydział</span></th>
        <th width="20%"><span>Status</span></th>
        <th width="20%"><span>Uwagi</span></th>
        <th width="15%"><span>Data otwarcia</span></th>
        <th width="15%"><span>Data zamknięcia</span></th>
        <th width="10%"></th>
      </tr>
    </thead>
    <tbody>
    {wlasneData.length > 0 ? (wlasneData.map((data, index) => {
        const { nazwaUchwaly, nazwaWydzialu, dataOtw, status, uwagi, dataZamk, idUchwaly, idWydzialu} = data;
        let { indexwyb } = this.state;
        let lp = index + 1;
        return (<>
        <tr className={index === indexwyb ? "opiniawyb" : null}>
            <td>{lp}</td>
            <td>{nazwaUchwaly}</td>
            <td>{nazwaWydzialu}</td>
            <td>{status}</td>
            <td>{uwagi}</td>
            <td>{this.getParsedDate(dataOtw)}</td>
            <td>{this.getParsedDate(dataZamk)}</td>
            <td><button type="button" class="btn btn-light text-nowrap  btn-sm"  data-toggle="modal" data-target="#opinieStatusyModal" onClick={() => (this.opiniowanieStatus(idUchwaly, idWydzialu))}> Statusy opinii </button></td>
        </tr>
        </>);
      })) : (<tr>
            <td colSpan="9"><center><b>Brak danych</b></center></td>
          </tr>)}
    </tbody>
  </table>
  </div></>) : null}

</div>
<hr />

</div>

</div>

<Popup open={this.state.open} closeOnDocumentClick onClose={this.closeModal}>
  <div class="oknouwagi">
    <a class="close point" onClick={this.closeModal}>&times;</a>
    <Zak_opiniowanie rok={this.props.rok} idopini={this.state.idopinizakoncz} iduchwaly={this.state.iduchwalyzakoncz} />
  </div>
</Popup>


<Popup open={this.state.open2} closeOnDocumentClick onClose={this.closeModal2}>
  <div class="oknouwagi">
    <a class="close point" onClick={this.closeModal2}>&times;</a>
    <Opiniuj2 idopini={this.state.idopini} idUchwaly={this.state.idUchwaly} rok={this.state.rok} idWydzialu={this.state.idWydzialu} uwagi={this.state.uwagi} nazwaOpiniodawcyDo={this.state.nazwaOpiniodawcyDo} closeModal2={this.closeModal2} getData1={this.getdata1} />
  </div>
</Popup>

<div class="modal" tabindex="-1" role="dialog" id="opiniowanieModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Opiniowanie</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body m-3">
        {opiniowanieData ? (<><select class="form-control p-2" id="selectOpiniowanie"  onChange={(e) => (this.setState({ opiniowanieValue: e.target.value}))}><option disabled selected hidden>Wybierz</option>{opiniowanieData.map((data, idx) => { const value = JSON.stringify(data); return (<>{data.pomin === 'N' ? (<option key={idx} value={value}>{data.nazwaOpiniodawcy}, {data.czyOpiniowal}</option>) : null }</>) } )}</select></>) : (<div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>) }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger mr-auto" onClick={(e) => (this.deleteOpiniowanie(e))}>Usuń</button>
        {opiniowanieValue ? (<button type="button" class="btn btn-primary" onClick={(e) => (this.postOpiniowanie(e))}>Zapisz</button>) : (<button type="button" class="btn btn-primary" disabled>Zapisz</button>)}
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Zamknij</button>  
      </div>
    </div>
  </div>
</div>


<div class="modal" tabindex="-1" role="dialog" id="opinieStatusyModal">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Statusy opinii</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      <table className='table table-striped'>
        <thead>
            <tr>
              <th>Opiniodawca</th>
              <th>Nazwa wydziału</th>
              <th>Opis</th>
              <th>Status</th>
            </tr>
        </thead>
        <tbody>
          {loadingStatusyOpinii && <div className='d-flex flex-row justify-content-center w-100'><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>} 
          
          {opiniowanieStatusData && opiniowanieStatusData.length > 0 ? (<>{opiniowanieStatusData.map((data, idx) => {
            const uwagishort = data.uwagi.substring(0,10);
            const uwagiFull = this.state;
            return (<tr key={idx}>
                <td>{data.opiniodawca}</td>
                <td>{data.nazwaWydz}</td>
                <td >{data.uwagi.length > 10 ? (<>{uwagiFull ? (<span>{data.uwagi}</span>) : (<span>{uwagishort}...</span>)}</>) : (<span>{data.uwagi}</span>)}</td>
                <td>{data.status}</td>
            </tr>)
          })}</>) : (<td colSpan={4}><p className='text-center'>Brak danych</p></td>)}
        </tbody>
      </table>
      </div>
    </div>
  </div>
</div>

</React.Fragment>
);
}
}


